<template>
	<span>
		<span>{{ getterVariationPrice }}</span>
		<span class="is-size-4">{{ getterVariationCurrency }}</span>
	</span>
</template>
<style lang="scss" scoped></style>
<script type="text/javascript">
	export default {
		props: ["product_display_price_prop", "product_display_currency_prop"],
		data() {
			return {
				state: this.$store.state,
				choices: null,
				productVariationPrice: 0,
				productVariationCurrency: null,
			};
		},
		mounted() {},
		computed: {
			getterVariationPrice() {
				if (!this.allChoicesHaveValues()) {
					return this.product_display_price_prop;
				}
				return "$" + this.productVariationPrice?.toFixed(2);
			},
			getterVariationCurrency() {
				if (!this.allChoicesHaveValues()) {
					return this.product_display_currency_prop;
				}
				return this.productVariationCurrency ?? "";
			},
		},
		methods: {
			getValuesFromState() {
				this.productVariationPrice =
					this.$store.getters.productVariationPrice;
				this.productVariationCurrency =
					this.$store.getters.productVariationCurrency;
				this.choices = this.$store.getters.choices;
			},
			allChoicesHaveValues() {
				return this.$store.getters.allChoicesHaveValues;
			},
		},
		watch: {
			state: {
				deep: true,
				handler() {
					this.getValuesFromState();
				},
			},
		},
	};
</script>
